<a href="/" class="relative py-2">
  <h1 class="font-display text-3xl font-black text-white py-4 relative z-10">
    Paimon
    <span class="absolute right-0 text-xl text-primary z-10" style="top: 5px;">.moe</span>
  </h1>
</a>
